import type { ClientBrainAction } from "../../features/clientBrainActions/models";
import type { DataScope, SourceSelector, WorkflowStatisticsQuery, WorkflowDataQuery } from "../../features/workflowData/models";
import type { BoxTaskSettings } from "./boxTaskTypes";

export type MainNodeKind = "trigger" | "step" | "outcome";
export type SubflowNodeKind = "subflow" | "subflow_step";
export type NodeKind = MainNodeKind | SubflowNodeKind;
export type WorkflowNodeDisplayMode = "content" | "source_links";
export type WorkflowOutputType = "text" | "select";
export type WorkflowContextSelector = SourceSelector;

export interface WorkflowSelectOption {
    value: string;
    label: string;
}

export interface WorkflowOutputConfiguration {
    client_brain_action?: ClientBrainAction | null;
    analytics?: WorkflowStatisticsQuery | null;
    output_type?: WorkflowOutputType;
    options?: WorkflowSelectOption[];
    context_selectors?: WorkflowContextSelector[];
}

export type WorkflowNodeSelection =
    | { workflowId: string; nodeKind: MainNodeKind; nodeId: string }
    | { workflowId: string; nodeKind: "subflow"; nodeId: string }
    | { workflowId: string; nodeKind: "subflow_step"; subflowId: string; nodeId: string };

export interface TriggerNode {
    id: string;
    title?: string;
    description: string;
}

export interface StepNode extends WorkflowOutputConfiguration {
    task_settings?: BoxTaskSettings;
    id: string;
    title?: string;
    description: string;
    display_mode?: WorkflowNodeDisplayMode;
}

export interface OutcomeNode extends WorkflowOutputConfiguration {
    task_settings?: BoxTaskSettings;
    id: string;
    title?: string;
    description: string;
    display_mode?: WorkflowNodeDisplayMode;
}

export interface Subflow extends WorkflowOutputConfiguration {
    task_settings?: BoxTaskSettings;
    id: string;
    title?: string;
    description: string;
    display_mode?: WorkflowNodeDisplayMode;
    steps: StepNode[];
}

export interface NoteWorkflow {
    timezone?: string;
    data_query?: WorkflowDataQuery | null;
    data_scope?: DataScope | null;
    id: string;
    view_all_boxes?: boolean;
    trigger: TriggerNode;
    steps: StepNode[];
    outcomes: OutcomeNode[];
    subflows?: Subflow[];
}

export interface NoteWorkflowsDocument {
    schema_version: number;
    workflows: NoteWorkflow[];
    updated_at?: number;
    updated_by?: string;
}

export const EMPTY_NOTE_WORKFLOWS_DOCUMENT: NoteWorkflowsDocument = {
    schema_version: 1,
    workflows: []
};
